"use client";

import { Button } from "@/components/ui/button";
import Image from "next/image";
import { useRouter } from "next/navigation";

const NotFound = () => {
  const router = useRouter();
  const isPartnerEnv = process.env.NEXT_PUBLIC_ENV_TYPE === "PARTNER";
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-6 max-w-[400px]">
        <Image src="/images/not_found.png" alt="404" width={160} height={160} />
        <div className="flex flex-col gap-3 items-center">
          <span className="text-[32px] bg-linear-to-r from-[#FFFFF7] to-[#FFFFF757] bg-clip-text text-transparent">
            Page not Found
          </span>
          <span className="text-xl text-[#FFFFFFBF] text-center">
            The page you're looking for doesn't exist or has been moved
          </span>
        </div>
        {isPartnerEnv ? (
          <Button onClick={() => router.push("/copilot")}>Back to Copilot</Button>
        ) : (
          <Button onClick={() => router.push("/profile")}>Back to Home</Button>
        )}
      </div>
    </div>
  );
};

export default NotFound;
